import type { ServerResponse } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export async function closeEvent(eventVaultId: number) {
  const response = await axios.patch<ServerResponse<boolean>>(`/api/event/${eventVaultId}/close`)

  return response.data.Data
}

const CLOSE_EVENT_KEY = "closeEvent"

export function useCloseEvent() {
  return useMutation({
    mutationKey: [CLOSE_EVENT_KEY],
    mutationFn: (eventVaultId: number) => closeEvent(eventVaultId),
  })
}
